import { Dispatch, SetStateAction, useState } from 'react';

export default function useValidatedState<T = unknown>(
  validation: (value: T | undefined) => { error: boolean; text?: string },
  initialValue?: T | undefined
): [
  T | undefined,
  Dispatch<SetStateAction<T | undefined>>,
  { error: boolean; text?: string }
];

export default function useValidatedState<T>(
  validation: (value: T | undefined) => { error: boolean; text?: string },
  initialValue?: T | undefined
): [
  T | undefined,
  Dispatch<SetStateAction<T | undefined>>,
  { error: boolean; text?: string }
] {
  const [value, setValue] = useState<T | undefined>(initialValue);
  return [value, setValue, validation(value)];
}
